const Version = () => {
  return (
    <div className="version mt-1 ">
      v {process.env.REACT_APP_WEBVIEW_VERSION}
    </div>
  )
}

export default Version
